/**
* Large Accordian Lists JS
* -----------------------------------------------------------------------------
*
* All the JS for the Large Accordian Lists component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'large-accordian-lists',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.large-accordian-lists__item-title' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'large-accordian-lists', COMPONENT );
} )( app );
